import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Dialog, DialogActions, DialogContentText, DialogTitle, DialogContent, Button
} from '@mui/material';
import Loader from '../components/loaders';
import { SSOLoginAction } from '@ivymobi/orbit-core/business/user';
import _ from 'lodash';
import {useTranslation} from 'react-i18next';

// 单点登录重定向逻辑
// 系统跳转到当前页面且通过URL参数可以获取到可识别的登录信息（userObj不为空）
// 若已有登录态，先静默清除 session（不触发 ABB 退出跳转），再调用 loginWithSSO

export default function RedirectContainer(props) {
  const [t] = useTranslation();
  const { user, logout } = props;
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [noUser, setNoUser] = useState(false);
  const handledRef = useRef(false);

  const searctStr = location?.search;
  const spliteStr = searctStr.slice(6);
  let decodeStr;
  try {
    decodeStr = decodeURI(spliteStr);
  } catch (e) {
    decodeStr = undefined;
  }

  const userObj = _.isEmpty(decodeStr) ? {} : JSON.parse(decodeStr);
  const [SSOMessage] = useState(userObj);

  const env = process.env.NODE_ENV || 'production';
  const abbURL = env === 'development' ? 'https://abbdrives.ivymobi.com.cn' : 'https://abbdrives.yangben.cn';
  const inviteUrl = env === 'development'
    ? 'https://lite.ivymobi.com.cn/invitations/ac8e8e96-3726-410d-a3b5-ee5b68e33948'
    : 'https://lite.yangbentong.com/invitations/7a716912-fb03-435f-8513-18d9945856c2';

  useEffect(() => {
    if (_.isEmpty(SSOMessage) || handledRef.current) {
      return;
    }
    handledRef.current = true;

    const runSSOLogin = async () => {
      if (!_.isEmpty(user)) {
        await logout({ skipAbbRedirect: true });
      }

      try {
        const res = await dispatch(SSOLoginAction({
          tenantId: SSOMessage.TNTID,
          email: SSOMessage.profile.email,
          other_token: SSOMessage.token,
        }));
        const resToken = _.get(res, ['token'], '');
        localStorage.setItem('tenantId', SSOMessage.TNTID);
        localStorage.setItem('token', resToken);
        localStorage.setItem('SSOLOGIN', 'true');
        navigate('/documents', { replace: true });
        navigate(0);
      } catch (err) {
        window.location.href = inviteUrl;
      }
    };

    runSSOLogin();
  }, [dispatch, SSOMessage, user, logout, navigate, inviteUrl]);

  const handleClose = () => {
  };

  const handleConfirm = () => {
    window.location.href = abbURL;
  };
  return (
    <>
      <Loader />
      <Dialog
        open={noUser}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">{"登录失败"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description" style={{ color: '#000' }}>
            请联系管理员 jessie-minjie.zhang@cn.abb.com 申请权限
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirm} color="primary">
            {t('confirm')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
